/**
 * De klantenlijst als query: dezelfde sleutel voor de lijst links en voor
 * de pagina (die opent de bovenste klant), dus één verzoek.
 */
import { useQuery } from "@tanstack/react-query";

import { v6Api } from "../api";
import { v6Sleutels } from "../sleutels";

type KlantenLijstData = Awaited<ReturnType<typeof v6Api.klantenLijst>>;

export function useKlantenLijst(zoek: string) {
  return useQuery<KlantenLijstData>({
    queryKey: v6Sleutels.klantenLijst(zoek),
    queryFn: () => v6Api.klantenLijst(zoek || undefined),
    placeholderData: (vorige) => vorige,
  });
}
